import { Injectable } from "@angular/core";
import { MonthTimetable, TestEvent } from "../models/event.model";

@Injectable({ providedIn: "root" })
export class TimetableService {
  private timetableData: MonthTimetable = {
    Online: [
      {
        date: "",
        name: "Topic Test",
        description: "M01 Maths Numbers, Factors",
        testtype: "ECOMP01 (GL) - 1st English Comprehension",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/218d86ce2079bd5b9a411b225bb287d6",
          },
        ],
      },

      {
        date: "",
        name: "Topic Test",
        testtype: "M02 Math's Decimal",
        description: "ECOMP02 (CSSE) - 2nd English Comprehension",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6ea4fb3613ffaacc90bfff4c953b6139",
          },
        ],
      },

      {
        date: "",
        name: "Topic Test",
        testtype: "M03 Math's Fractions",
        description: "VRNVR01 - 1st Verbal Non-Verbal Reasoning & CW01",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8a02e6eaab1c563dae80fec01f9da8d1",
          },

        ],
      },

      {
        date: "",
        name: "Topic Test",
        description: "M04 Math's Percentage",
        testtype: "ECOMP03 (GL) - 3rd English Comprehension",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/32e76b70b4cb9ee325e6915f120c849d",
          },
        ],
      },

      {
        date: "",
        name: "Topic Test",
        description: "M05 Math's Money",
        testtype: "ECOMP04 (CSSE) - 4th English Comprehension",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/3c6db2343a945d5015cbbbe1269eb74f",
          },
        ],
      },

      {
        date: "",
        name: "M06",
        description: "Math's Data Handling Part 1",
        testtype:
          "VRNVR02 - 2nd Verbal Non-Verbal Reasoning & CW02",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/9be51202d2667190239bdbaae08e5581",
          },
        ],
      },

      {
        date: "",
        name: "Topic Test",
        description: "M07 Maths Day, Date and Time",
        testtype:
          "ECOMP05 (GL) - 5th English Comprehension",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6d94b569d831df67fb0e31e27a976944",
          },
        ],
      },

      {
        date: "",
        name: "Topic Test",
        description: "M04 Math's Percentage",
        testtype: "ECOMP03 (GL) - 3rd English Comprehension",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e276b44a5befb9ca2eda836a2e0989c8",
          },
        ],
      },

      {
        date: "",
        name: "MR01",
        description: "1st Math's Revision",
        testtype: "",
        centers: [
          {
            
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/f449fec9679f6909ad182b9d48bf9013",
          },
        ],
      },

      {
        date: "",
        name: "Topic Test",
        description: "M05 Math's Money",
        testtype: "ECOMP04 (CSSE) - 4th English Comprehension",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6b30a55c0a757c103de800d908abc32e",
          },
        ],
      },

      {
        date: "",
        name: "M06",
        description: "Math's Data Handling Part 1",
        testtype:
          "VRNVR02 - 2nd Verbal Non-Verbal Reasoning & CW02",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99",
          },
        ],
      },

      {
        date: "",
        name: "Topic Test",
        description: "M07 Maths Day, Date and Time",
        testtype:
          "ECOMP05 (GL) - 5th English Comprehension",
        centers: [
          {
            name: "Online",
            time: "From: 04/04/2025",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99",
          },
        ],
      },

      //--------------------- MOCK TESTS ENDS HERE  ---------------------//



       //--------------------- YEAR 04 TOPIC TESTS STARTS HERE  ---------------------//

       

    ],
  };

  getMonths(): string[] {
    return ["Online", ];
  }

  getTimetable(): MonthTimetable {
    return this.timetableData;
  }
}
